import { gql } from 'apollo-angular';

export const destroyOidcMutation = gql`
  mutation DestroyOIDC($input: DestroyOIDCInput!) {
    destroyOidc(input: $input) {
      errors {
        message
        path
      }

      oidc {
        id
      }
    }
  }
`;
